import React, {Suspense, lazy, useEffect, useMemo, useState} from "react"
import {Card} from "react-bootstrap"
import Dropdown from "react-bootstrap/Dropdown"
import {AiOutlineClose} from "react-icons/ai"
import {BiSearchAlt2} from "react-icons/bi"
import {useIntl} from "react-intl"
import {useSelector} from "react-redux/es/exports"
import {useNavigate} from "react-router-dom"
import {openLink} from "../../utils"
import DropDownItem from "./DropDownItem"
import {MdNotifications} from "react-icons/md"
import {ComponentLoader} from "../Loader/Loader"
import {useMediaQuery} from "react-responsive"
const NavBarModal = lazy(() => import("./NavBarModal"))
const Notifications = lazy(() => import("./Notifications"))

const NavBar = ({generalDetails}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const navigationMenu = useSelector(
    (state) => state.navigationMenu.navigationMenu
  )
  const isSmallScreen = useMediaQuery({maxWidth: 991})
  const [nav, setnav] = useState("")
  const [sticky, setsticky] = useState("")
  const fixed = false
  const [show, setShow] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [generalSearch, setGeneralSearch] = useState(false)
  const [categoryText, setCategoryText] = useState(
    intl.formatMessage({id: "GENERAL_SEARCH_DROPDOWN_POSTS_VALUE"})
  )
  const [showError, setShowError] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const accessToken = sessionStorage.getItem("accessToken")

  const joinedCommunitiesData = useSelector(
    (state) => state.communities.joinedCommunities
  )

  const allCommunities = useSelector((state) => state.communities.communities)
  const communitiesNotifications = useSelector(
    (state) => state?.communities?.communitiesNotifications
  )

  const memoizedCommunities = useMemo(
    () => communitiesNotifications,
    [communitiesNotifications]
  )

  const showCommunities = () => {
    if (
      (Object.keys(joinedCommunitiesData).length === 0 &&
        Object.keys(allCommunities).length === 0) ||
      !accessToken
    ) {
      return false
    } else {
      return true
    }
  }

  useEffect(() => {
    setnav(document.getElementById("main-nav"))
    setsticky(nav?.offsetTop)
    window.addEventListener("scroll", handleSticky)
    return () => window.removeEventListener("scroll", handleSticky)
  }, [nav, sticky])

  const onSearchTextChange = (text) => {
    setSearchText(text || "")
  }

  useEffect(() => {
    document.querySelectorAll(".dropdown-menu a").forEach(function (element) {
      element.addEventListener("click", handleSubMenu)
    })
    return () =>
      document
        .querySelectorAll(".dropdown-menu a")
        .forEach((ele) => ele.removeEventListener("click", handleSubMenu))
  }, [])

  const handleSubMenu = (e) => {
    let nextEl = this.nextElementSibling
    if (nextEl && nextEl?.classList?.contains("submenu")) {
      e.preventDefault()
      if (nextEl.style.display === "block") {
        nextEl.style.display = "none"
      } else {
        nextEl.style.display = "block"
      }
    }
  }

  const handleSticky = () => {
    let navbar = document.getElementById("main-nav")
    let container = document.getElementById("top_most_container")
    if (window.pageYOffset > sticky) {
      navbar.classList.add("fixed-top")
      container.style.marginTop = "60px"
    } else {
      navbar.classList.remove("fixed-top")
      container.style.marginTop = "0px"
    }
  }
  const leavePage = (page) => {
    navigate(`/${page.toLowerCase()}`)
  }

  const goToHome = () => {
    navigate("/")
  }

  const handleGeneralSearch = () => {
    if (searchText && searchText.length >= 3) {
      navigate(`/general-search/${searchText}/${categoryText}/1`)
      setShowError(false)
      setGeneralSearch(false)
    } else {
      setShowError(true)
    }
  }

  const isNewNotifications = () => {
    return memoizedCommunities?.some((item) => item.is_seen == 0)
  }

  return (
    <>
      <div
        id="main-nav"
        className={`navigation-wrap navigation-shadow  ${
          fixed ? "fixed-top" : ""
        }`}
      >
        <nav className="navbar navbar-expand-lg navbar-soft">
          <div className="container-fluid">
            <div className="d-flex logo-spacing">
              <img
                onClick={goToHome}
                src={generalDetails?.logo_url}
                alt="header-logo"
                className="navbar-logo"
                style={{height: "40px", width: "50px", objectFit: "contain"}}
              />
              <div className="d-flex justify-content-center align-items-center">
                {showCommunities() && (
                  <span
                    className="me-3 w-50px h-50px cursor-pointer position-relative navbar_notifications"
                    type="button"
                    onClick={() => {
                      setShowNotifications(true)
                    }}
                  >
                    <MdNotifications
                      style={{color: "var(--accent-textcolor)"}}
                      size={25}
                    />
                    {isNewNotifications() && (
                      <span
                        className="rounded rounded-circle d-flex justify-content-center align-items-center bg-danger position-absolute translate-end top-0 start-50"
                        style={{
                          width:
                          memoizedCommunities?.filter(
                              (item) => item.is_seen === 0
                            )?.length > 99
                              ? "20px"
                              : "16px",
                          height: "16px",
                          color: "var(--accent-textcolor)",
                        }}
                      >
                        <span
                          className="text-white fw-bold"
                          style={{fontSize: "10px"}}
                        >
                          {
                            memoizedCommunities?.filter(
                              (item) => item.is_seen === 0
                            )?.length
                          }
                          {memoizedCommunities?.filter(
                            (item) => item.is_seen === 0
                          )?.length > 99 && (
                            <span className="text-white">+</span>
                          )}
                        </span>
                      </span>
                    )}
                  </span>
                )}
                <button
                  className="navbar-toggler"
                  type="button"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  onClick={() => setShow(true)}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
            </div>

            {!isSmallScreen && (
              <div
                className="collapse navbar-collapse justify-content-between"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                  {!!navigationMenu.length
                    ? navigationMenu.map((item) => {
                        return !item.children.length > 0 ? (
                          <li
                            key={item?.id}
                            className="nav-item active"
                          >
                            <button
                              className="nav-link active"
                              onClick={() => {
                                if (item.page_type === "link") {
                                  if (item.link_url_opening === 0) {
                                    window.open(item.link_url, "_self")
                                  } else {
                                    openLink(item.link_url)
                                  }
                                } else {
                                  leavePage(item.seo_permalink)
                                }
                              }}
                            >
                              {item.name}
                            </button>
                          </li>
                        ) : (
                          <li
                            key={item.id}
                            className="nav-item active dropdown"
                          >
                            <button
                              className="nav-link active dropdown-toggle"
                              id="navbarDropdown"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={() => {
                                if (item.page_type === "link") {
                                  if (item.link_url_opening === 0) {
                                    window.open(item.link_url, "_self")
                                  } else {
                                    openLink(item.link_url)
                                  }
                                } else {
                                  leavePage(item.seo_permalink)
                                }
                              }}
                            >
                              {item.name}
                            </button>
                            {item.children.length > 0 ? (
                              <ul
                                className="dropdown-menu main-dropdown animate animatedFadeInUp fadeInUp border-0"
                                aria-labelledby="navbarDropdown"
                                style={{
                                  boxShadow:
                                    "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
                                }}
                              >
                                {item.children.map((i) => {
                                  return (
                                    <DropDownItem
                                      key={i.id}
                                      id={i.id}
                                      name={i.name}
                                      link={i.seo_permalink}
                                      className={
                                        i.children.length > 0
                                          ? "icon-arrow arrow-align"
                                          : "d-block"
                                      }
                                      item={i}
                                    >
                                      {i.children.length > 0 ? (
                                        <ul
                                          className="submenu dropdown-menu  animate animatedFadeInUp fadeInUp border-0"
                                          style={{
                                            boxShadow:
                                              "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
                                          }}
                                        >
                                          {i.children.map((entry) => (
                                            <DropDownItem
                                              key={entry.id}
                                              id={entry.id}
                                              name={entry.name}
                                              link={entry.seo_permalink}
                                              item={entry}
                                            ></DropDownItem>
                                          ))}
                                        </ul>
                                      ) : (
                                        ""
                                      )}
                                    </DropDownItem>
                                  )
                                })}
                              </ul>
                            ) : (
                              ""
                            )}
                          </li>
                        )
                      })
                    : ""}
                  <ul
                    className="mb-2 mb-lg-0 d-flex align-items-center generalSearch position-absolute"
                    style={{margin: 0, right: "60px", top: "20px"}}
                    onClick={() => {
                      setGeneralSearch(!generalSearch)
                    }}
                  >
                    <BiSearchAlt2
                      style={{
                        fontSize: "20px",
                      }}
                      type="button"
                    />
                  </ul>
                </ul>
              </div>
            )}
          </div>
        </nav>
        <div className="position-relative">
          {generalSearch ? (
            <div
              className={`navigation-wrap navigation-shadow w-100`}
              style={{
                position: "absolute",
                zIndex: "1030",
              }}
            >
              <div className="position-absolute generalSearchPopup">
                <Card>
                  <Card.Header className="generalSearchCloseIcon">
                    <AiOutlineClose
                      style={{
                        fontSize: "20px",
                      }}
                      onClick={() => {
                        setGeneralSearch(false)
                        setSearchText("")
                      }}
                      type="button"
                    />
                  </Card.Header>
                  <Card.Body>
                    <div
                      className="d-flex align-items-center "
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleGeneralSearch()
                        }
                      }}
                    >
                      <input
                        type="text"
                        className="form-control form-control-solid ps-15 mx-2"
                        placeholder={intl.formatMessage({
                          id: "LABEL_ENTER_SEARCH_TEXT",
                        })}
                        autoFocus
                        value={searchText}
                        onChange={(e) => {
                          if (e.target.value.length >= 3) {
                            setShowError(false)
                          }
                          onSearchTextChange(e.target.value)
                        }}
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          width: "500px",
                        }}
                      />
                      <div className="me-2">
                        <Dropdown>
                          <Dropdown.Toggle id="dropdown-basic">
                            {categoryText}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setCategoryText(
                                  intl.formatMessage({
                                    id: "GENERAL_SEARCH_DROPDOWN_POSTS_VALUE",
                                  })
                                )
                              }}
                            >
                              {intl.formatMessage({
                                id: "GENERAL_SEARCH_DROPDOWN_POSTS_VALUE",
                              })}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setCategoryText(
                                  intl.formatMessage({
                                    id: "GENERAL_SEARCH_DROPDOWN_EVENTS_VALUE",
                                  })
                                )
                              }}
                            >
                              {intl.formatMessage({
                                id: "GENERAL_SEARCH_DROPDOWN_EVENTS_VALUE",
                              })}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setCategoryText(
                                  intl.formatMessage({
                                    id: "GENERAL_SEARCH_DROPDOWN_COURSES_VALUE",
                                  })
                                )
                              }}
                            >
                              {intl.formatMessage({
                                id: "GENERAL_SEARCH_DROPDOWN_COURSES_VALUE",
                              })}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div
                        className="p-2  d-flex  align-items-center popupSearch"
                        onClick={() => {
                          handleGeneralSearch()
                        }}
                        style={{
                          borderRadius: "5px",
                        }}
                      >
                        <BiSearchAlt2
                          style={{
                            fontSize: "21px",
                            color: "#ffff",
                          }}
                          type="button"
                        />
                      </div>
                    </div>
                    {showError && (
                      <div
                        className="d-flex align-items-center text-danger mx-2 "
                        style={{fontSize: "13px"}}
                      >
                        {intl.formatMessage({
                          id: "GENERAL_SEARCH_ERROR_MESSAGE",
                        })}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {showNotifications && (
        <Suspense fallback={<ComponentLoader />}>
          <Notifications
            show={showNotifications}
            handleClose={() => {
              setShowNotifications(false)
            }}
            id="navbar"
          />
        </Suspense>
      )}
      <Suspense fallback={<ComponentLoader />}>
        <NavBarModal
          show={show}
          handleClose={() => setShow(false)}
        />
      </Suspense>
    </>
  )
}

export default NavBar
